import type { StaticApplicationsAdvisorNovAgeSkincareConfigurationDto } from '@ori/static-api-client-react';

export const isValidNovageSkincareConfiguration = (
  configuration: StaticApplicationsAdvisorNovAgeSkincareConfigurationDto | undefined,
): configuration is Required<StaticApplicationsAdvisorNovAgeSkincareConfigurationDto> =>
  Boolean(configuration?.environment && configuration.partnerId);
